import React from 'react';
import { Box, BoxProps, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const outerBoxProps: BoxProps['sx'] = {
  display: 'inline-block',
  alignItems: 'center',
  borderRadius: '20px',
  overflow: 'hidden',
  position: 'relative',
  padding: '2px',
  background: 'linear-gradient(90deg, #DB86F8 0%, #006FD6 100%)',
};

const innerBoxProps: BoxProps['sx'] = {
  display: 'inline-block',
  backgroundColor: '#1E293B',
  color: 'white',
  fontSize: '15px',
  padding: '0px 15px 15px 15px',
  borderRadius: '20px',
  textAlign: 'center',
};

const popupContainerProps: BoxProps['sx'] = {
  position: 'absolute',
  top: '100%',
  right: '30px',
  marginTop: '15px',
  width: '320px',
  zIndex: 1000,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-10px',
    right: '150px',
    width: '0',
    height: '0',
    borderLeft: '10px solid transparent',
    borderRight: '10px solid transparent',
    borderBottom: '10px solid #1E293B',
  },
};

interface WelcomePopupProps {
  userName: string;
  onClose: () => void;
  completionPercentage: number;
}

const WelcomePopup: React.FC<WelcomePopupProps> = ({
  userName,
  onClose,
  completionPercentage,
}) => {
  const getWelcomeMessage = () => {
    if (completionPercentage === 0) return `Hi, ${userName}`;
    if (completionPercentage === 100) return `Congratulations, ${userName}!`;
    return `Welcome Back, ${userName}`;
  };

  const getProgressMessage = () => {
    if (completionPercentage === 0) {
      return "Let's start your learning journey! Complete the Resources, Practice Questions & Quiz to master this sub-topic.";
    }
    if (completionPercentage === 100) {
      return "Amazing work! You've mastered this sub-topic by completing all Resources, Practice Questions & Quiz. Keep up the great work!";
    }
    return `You have completed ${Math.round(
      completionPercentage
    )}% of this sub-topic, complete the Resources, Practice Questions & Quiz to make it 100%`;
  };

  return (
    <Box sx={popupContainerProps}>
      <Box sx={outerBoxProps}>
        <Box sx={innerBoxProps}>
          <img
            src={`${process.env.PUBLIC_URL}/images/subtopicPage/target.png`}
            alt="target-icon"
            style={{
              width: '140px',
              height: '140px',
            }}
          />

          <Typography sx={{ mb: 1, fontWeight: 600, fontSize: '18px' }}>
            {getWelcomeMessage()}
          </Typography>

          <Typography sx={{ color: '#94A3B8', fontSize: '14px', mb: 1 }}>
            {getProgressMessage()}
          </Typography>

          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: '12px',
              top: '12px',
              color: 'white',
              padding: '4px',
            }}
          >
            <CloseIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default WelcomePopup;
